export default __webpack_public_path__ + "static/media/info-icon.55dc5dd2.svg";